export default __webpack_public_path__ + "static/media/acm_modal_banner_arrow.60a898be.png";